import { ReactComponent as ISOLogoIcon } from "../assets/isotipo.svg";
import { useLocation } from "react-router-dom";
import { SignInForm } from "./signin-form";
import bgLogin from "../assets/bgLogin.jpg";

const LoginWrapper = () => {
  const location = useLocation();

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-cover bg-center relative bg-fixed overflow-hidden"
      style={{ backgroundImage: `url(${bgLogin})` }}
    >
      <div className="absolute inset-0 bg-black opacity-50 z-0" />

      <div className="relative w-full max-w-md p-8 bg-[#F8F9FA] shadow-xl rounded-2xl bg-opacity-80 text-gray-900 border border-gray-300 z-10">
        <h2 className="text-2xl font-semibold text-center mb-6">¡Bienvenido!</h2>
        <SignInForm route={location.state?.from} />

        <div className="mt-6 text-center text-sm text-gray-600">
          <p>
            ¿No tienes cuenta?{" "}
            <a href="/signup" className="text-[#6C757D] hover:underline">
              Regístrate
            </a>
          </p>
          <p className="mt-2 text-gray-600">
            <a href="/forgot-credentials" className="hover:underline">
              ¿Olvidaste tu usuario o contraseña?
            </a>
          </p>
        </div>

        <div className="mt-6 flex items-center justify-center gap-2 text-gray-600 text-xs">
          <span>Powered by</span>
          <ISOLogoIcon className="w-8" />
          Hiva
        </div>
      </div>
    </div>
  );
};

export default LoginWrapper;
